import { BackendErrorContext, BackendErrorText, BACKEND_ERROR_TEXT_MESSAGES, getErrorReason } from 'shared/errors';
import { i18n } from 'shared/i18n';

// Тексты живут в реестре `shared/errors` (раздел «по тексту»); псевдонимы — для тестов и экранов.
export const WALLET_TOPUP_RECEIPT_EMAIL_ERROR = BACKEND_ERROR_TEXT_MESSAGES[BackendErrorText.RECEIPT_EMAIL_INVALID];
export const WALLET_TOPUP_NOT_ENOUGH_MONEY = BACKEND_ERROR_TEXT_MESSAGES[BackendErrorText.NOT_ENOUGH_MONEY];
export const WALLET_TOPUP_CARD_DISABLED = BACKEND_ERROR_TEXT_MESSAGES[BackendErrorText.CARD_PAYMENTS_DISABLED];

/**
 * Текст отказа пополнения или покупки тарифа: переведённая причина из общего реестра (по коду —
 * например, 18020 «сумма указана неверно»; по тексту — «недостаточно средств», «email для чека»),
 * иначе `fallback` экрана. Сырой текст бэкенда — даже русский — не показываем: только переведённое.
 */
export function walletTopupErrorMessage(error: unknown, fallback: string): string {
  const reason = getErrorReason(error, { context: BackendErrorContext.WALLET });
  return reason ? i18n._(reason) : fallback;
}
